import React, { Fragment, Component } from "react";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { ReportHeaderSchema, SchemaBody, SchemaHeader2, Schemaheader, certifyHeader } from "./Schema";
import { CRUDFunction } from "../../../../reduxCURD/container";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { languageService } from "../../../../Language/language.service";

// let assetID = "6655debde9af8654e8aee5a2";

class NonComplaintMaintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetInfo: {},
      filteredData: {},
    };
    this.filterData = this.filterData.bind(this);
  }

  componentDidMount() {
    if (this.props.selectedAssetId) {
      this.props.getNonComplaintMaintenanceInfo(`${this.props.selectedAssetId}`);
    }
  }

  componentDidUpdate(prevProps) {
    const { NonComplaintMaintenanceInfo, actionType } = this.props;

    if (actionType === "NONCOMPLAINTMAINTENANCEINFO_READ_SUCCESS" && actionType !== prevProps.actionType) {
      this.setState({ assetInfo: NonComplaintMaintenanceInfo }, this.filterData);
    }
    if (prevProps.selectedAssetId !== this.props.selectedAssetId) {
      this.props.getNonComplaintMaintenanceInfo(`${this.props.selectedAssetId}`);
    }
  }

  filterData() {
    const { assetInfo } = this.state;
    const filteredData = { unitID: assetInfo.unitId, ...(assetInfo.attributes || {}) };
    this.setState({ filteredData });
  }
  sortDataByDate(list) {
    return list.sort((a, b) => new Date(b.date) - new Date(a.date));
  }
  render() {
    const { reportData, inspec } = this.props;
    const { filteredData } = this.state;
    let reportsByDateAndUser = null;
    let decodedReports = null;
    let inspections = null;

    if (!inspec) {
      let sortedReports = this.sortDataByDate(reportData);
      reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(sortedReports);
      decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);
    } else {
      if (inspec && Array.isArray(inspec)) {
        inspections = this.sortDataByDate(inspec);
      } else {
        inspections = [inspec];
      }
    }

    return (
      <React.Fragment>
        <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
          <ReportTitleSection title={languageService("Locomotive Maintenance Record")} fontSizeOverride={"35px"} />
          <table className="table-bordered">
            {ReportHeaderSchema.map(
              (e, i) =>
                filteredData &&
                Object.keys(filteredData).length > 0 && <ReportTableSectionRenderer key={i} section={e} rowsData={filteredData} />,
            )}
          </table>
          <span className="spacer" />
          {inspections ? (
            inspections.map((inspec, inspecIndex) => {
              const isMaintenance = this.props.isMaintenance ? this.props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
              const { maintenanceType } = this.props;
              const maintenanceFormsMap = {
                injector: ["injectorChangeRecord_m"],
                activity: ["maintenanceActivity_m"],
                default: ["maintenanceActivity_m", "injectorChangeRecord_m"], //default
              };
              const maintenanceForms = maintenanceFormsMap[maintenanceType] || maintenanceFormsMap.default;
              let formSummaries = isMaintenance
                ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, maintenanceForms, true)
                : ReportGeneratorUtils.getInspectionAssetAppForms(
                    inspec,
                    ["noncompliantmaintenance", "injectorChangeRecord"],
                    this.props.selectedAssetId,
                    true,
                  );
              let MType = null;
              let mrNumber = inspec.title;
              if (inspec && inspec.tasks[0] && inspec.tasks[0].workOrders && inspec.tasks[0].workOrders[0]) {
                MType = inspec.tasks[0].workOrders[0].maintenanceType;
              } else if (inspec && inspec.tasks[0] && inspec.tasks[0].orgMaintenances && inspec.tasks[0].orgMaintenances[0]) {
                MType = inspec.tasks[0].orgMaintenances[0].maintenanceType;
              }
              return (
                <table className="table-bordered">
                  {formSummaries.map((summary, i) => {
                    return (
                      <ReportView
                        {...this.props}
                        key={`${i}-${inspecIndex}`}
                        data={{
                          decodedData: [
                            {
                              summary: summary,
                              testCode: summary.testCode,
                            },
                          ],
                          date: ReportGeneratorUtils.getInspectionDate(inspec),
                          fraHeaderInfo: { userName: ReportGeneratorUtils.getInspectionUser(inspec).name },
                          isMaintenance: isMaintenance,
                        }}
                        mrNumber={mrNumber}
                        MType={MType}
                      />
                    );
                  })}
                </table>
              );
            })
          ) : (
            <table className="table-bordered">
              {decodedReports.map((report, i) => {
                return <ReportView key={i} data={report} {...this.props} />;
              })}
            </table>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const ReportView = (props) => {
  const { data, MType, mrNumber } = props;
  const { decodedData, date, fraHeaderInfo, isMaintenance } = data;
  const SchemaHeader = Schemaheader(isMaintenance);
  const testCode = decodedData[0] && decodedData[0].testCode;
  const header2Section = SchemaHeader2(testCode);
  const bodySection = SchemaBody(testCode);

  return (
    <Fragment>
      {decodedData[0] && decodedData[0].otherInfo && decodedData[0].otherInfo.certifiedBy && (
        <ReportTableSectionRenderer rowsData={{ ...decodedData[0].otherInfo, date: decodedData[0].date }} section={certifyHeader} />
      )}
      <ReportTableSectionRenderer
        rowsData={{
          uname: { name: fraHeaderInfo.userName, isMaintenance: data.isMaintenance },
          date: formatDate(date),
          testCode: testCode,
          mrNumber: mrNumber,
        }}
        section={SchemaHeader}
      />

      <ReportTableSectionRenderer rowsData={{}} section={header2Section} />

      {decodedData.map((report, i) => {
        const { testCode } = report;
        let dataList = null;
        if (report.summary && report.summary.repairsMade) {
          dataList = JSON.parse(JSON.stringify(report.summary.repairsMade));
        }
        if (dataList) {
          dataList.forEach((e) => {
            if (testCode === "injectorChangeRecord_m" || testCode === "injectorChangeRecord") {
              e.typeOfRep = "Engine";
            } else if (MType !== null) e.typeOfRep = MType;
          });
        }

        return dataList ? (
          <Fragment key={i}>
            <ReportTableSectionRenderer rowsData={dataList} section={bodySection} />
          </Fragment>
        ) : null;
      })}
    </Fragment>
  );
};

const NonComplaintReport = CRUDFunction(NonComplaintMaintenance, "NonComplaintMaintenanceInfo", null, null, null, "asset");

export default NonComplaintReport;

export function formatDate(dateStr) {
  // Parse the date string
  const date = new Date(dateStr);

  // Extract month, day, and year
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based, so add 1
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year

  // Format the date as MM-DD-YY
  const formattedDate = `${month}-${day}-${year}`;

  return formattedDate;
}



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/NonComplaintMaintanence/NonComplaintMaintanence.jsx